import { RepositoryBase } from '@app/repositories/RepositoryBase';

export class CoatingAreaTypeRepository<
    CoatingAreaTypeModel
> extends RepositoryBase<CoatingAreaTypeModel> {
    public constructor() {
        super('coatingAreaType');
    }
}
